import { render } from "./ResearchCard.vue?vue&type=template&id=930de7fa&scoped=true&bindings={}"
import script from "./ResearchCard.vue?vue&type=script&lang=ts"
export * from "./ResearchCard.vue?vue&type=script&lang=ts"

import "./ResearchCard.vue?vue&type=style&index=0&id=930de7fa&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-930de7fa"

export default script